export const leadsEn: Record<string, string> = {
  'leads.errors.createFailed': 'Failed to create lead',
  'leads.created': 'Created',
  'leads.boardSettings': 'Board Settings',
  'leads.boardSettingsUpdated': 'Board Settings Updated',
  'leads.boardSettingsDescription': 'Column visibility preferences have been saved.',
  'leads.columnVisibility': 'Column Visibility',
  'leads.visibleOf': '{visible} of {total} visible',
  'leads.columnVisibilityHint': 'Choose which stage columns to display on your Kanban board. Hidden stages remain accessible in search and reports.',
  'leads.applyChanges': 'Apply Changes',
  'leads.resetToDefaults': 'Reset to Organization Defaults',
  'leads.hiddenByDefault': 'Hidden by default',
  'leads.atLeastOneColumn': 'At least one column must be visible on the board.',
  'leads.title': 'Leads',
  'leads.newLead': 'New Lead',
  'leads.createNewLead': 'Create New Lead',
  'leads.success.created': 'Lead created successfully',
  'leads.success.stageUpdated': 'Lead stage updated successfully',
  'leads.createTitle': 'Create New Lead',
  'leads.create.cancel': 'Cancel',
  'leads.create.submit': 'Create Lead',
  'leads.create.submitting': 'Creating Lead...',
  'leads.create.quickCapture': 'Quick Lead Capture: Only first name OR email is required. All other information is optional and can be filled in later.',
  'leads.create.contactInfo': 'Contact Information',
  'leads.create.firstName': 'First Name',
  'leads.create.lastName': 'Last Name',
  'leads.create.email': 'Email',
  'leads.create.phone': 'Phone',
  'leads.create.details': 'Lead Details',
  'leads.create.source': 'Lead Source',
  'leads.create.selectSource': 'Select source',
  'leads.create.budgetMin': 'Budget Min ($)',
  'leads.create.budgetMax': 'Budget Max ($)',
  'leads.create.weddingDate': 'Wedding Date',
  'leads.create.notes': 'Notes',
  'leads.create.placeholder.firstName': 'First name',
  'leads.create.placeholder.lastName': 'Last name',
  'leads.create.placeholder.email': 'email@example.com',
  'leads.create.placeholder.phone': 'Phone number',
  'leads.create.placeholder.budgetMin': 'Min budget',
  'leads.create.placeholder.budgetMax': 'Max budget',
  'leads.create.placeholder.notes': 'Additional notes...',
  'leads.create.orgNotFound': 'Organization not found',
  'leads.create.stagesError': 'Failed to load lead stages',
  'leads.create.validation.nameOrEmail': 'Either first name or email is required',
  'leads.create.validation.emailInvalid': 'Email format is invalid',
  'leads.create.successDescription': 'Lead created successfully! All lead information has been captured.',
  'leads.errors.apiFailed': 'API Error: {message}',
  'leads.errors.loadFailed': 'Failed to load leads',
  'leads.errors.loadStagesFailed': 'Failed to load lead stages',
  'leads.errors.updateStageFailed': 'Failed to update lead stage',
  'leads.errors.deleteFailed': 'Failed to delete lead',
  'leads.errors.convertFailed': 'Failed to convert lead to customer',
  'leads.errors.noCustomerFound': 'No Customer Found',
  'leads.errors.noCustomerDescription': 'No customer record found for this lead. Convert the lead to customer first.',
  'leads.errors.contactUpdateFailed': 'Failed to update contact information',
  'leads.errors.eventUpdateFailed': 'Failed to update event details',
  'leads.errors.dressPrefsUpdateFailed': 'Failed to update dress preferences',
  'leads.errors.decisionUpdateFailed': 'Failed to update decision making information',
  'leads.success.deleted': 'Lead deleted successfully',
  'leads.success.converted': 'Lead converted to customer successfully and moved to final stage.',
  'leads.success.contactUpdated': 'Contact information updated successfully',
  'leads.success.eventUpdated': 'Event details updated successfully',
  'leads.success.dressPrefsUpdated': 'Dress preferences updated successfully',
  'leads.success.decisionUpdated': 'Decision making information updated successfully',
  'leads.searchPlaceholder': 'Search leads...',
  'leads.searchPlaceholderFull': 'Search by name, email, or phone...',
  'leads.allStages': 'All Stages',
  'leads.kanbanBoard': 'Kanban Board',
  'leads.tableView': 'Table View',
  'leads.showMore': 'Show {count} more',
  'leads.showLess': 'Show less',
  'leads.table.name': 'Name',
  'leads.table.contact': 'Contact',
  'leads.table.stage': 'Stage',
  'leads.table.source': 'Source',
  'leads.table.budget': 'Budget',
  'leads.table.weddingDate': 'Wedding Date',
  'leads.table.created': 'Created',
  'leads.assignedTo': 'Assigned to:',
  'leads.actions.viewCustomer': 'View Customer',
  'leads.actions.editLead': 'Edit Lead',
  'leads.actions.scheduleAppointment': 'Schedule Appointment',
  'leads.actions.converting': 'Converting...',
  'leads.actions.convertToCustomer': 'Convert to Customer',
  'leads.actions.deleteLead': 'Delete Lead',
  'leads.actions.editContact': 'Edit Contact',
  'leads.actions.editEventDetails': 'Edit Event Details',
  'leads.actions.editDressPrefs': 'Edit Dress Preferences',
  'leads.actions.editDecisionMaking': 'Edit Decision Making Info',
  'leads.editTitle': 'Edit Lead',
  'leads.bundles.basicContact': 'Basic Contact Bundle',
  'leads.bundles.eventDetails': 'Event Details Bundle',
  'leads.bundles.dressPreferences': 'Dress Preferences Bundle',
  'leads.bundles.decisionMaking': 'Decision Making Information',
  'leads.bundles.personalization': 'Personalization Capsule',
  'leads.bundles.leadManagement': 'Lead Management',
  'leads.bundles.crossSell': 'Cross-sell Opportunities',
  'leads.bundles.comments': 'Comments',
  'leads.bundles.appointmentHistory': 'Appointment History',
  'leads.bundles.leadActions': 'Lead Actions',
  'leads.appointmentHistoryTransferNote': 'Appointment history will automatically transfer when lead is converted to customer.',
  'leads.convertNote': 'When you convert this lead to a customer, all contact information will be transferred automatically.',
  'leads.deleteTitle': 'Delete Lead',
  'leads.deleteConfirmation': 'Are you sure you want to delete this lead for {name}? This action cannot be undone.',

  // History
  'history.title': 'History',
  'history.from_to': 'From {from} to {to}',
  'history.no_data': 'No history available',
  'history.no_data_description': 'Stage changes will appear here once the lead moves through different stages.',
  'history.transition': 'Stage transition',
  'history.load_more': 'Load more',
  'history.fetch_error': 'Failed to load history',

  // Detail: Basic Contact
  'leads.detail.basicContact.title': 'Basic Contact',
  'leads.detail.basicContact.noName': 'No name provided',

  // Detail: Contact Form
  'leads.detail.contactForm.customerTitle': 'Customer Contact Information',
  'leads.detail.contactForm.leadTitle': 'Lead Contact Information',
  'leads.detail.contactForm.firstName': 'First Name',
  'leads.detail.contactForm.lastName': 'Last Name',
  'leads.detail.contactForm.email': 'Email',
  'leads.detail.contactForm.phone': 'Phone',
  'leads.detail.contactForm.preferredComms': 'Preferred Communication',
  'leads.detail.contactForm.firstNamePlaceholder': 'Enter first name',
  'leads.detail.contactForm.lastNamePlaceholder': 'Enter last name',
  'leads.detail.contactForm.emailPlaceholder': 'Enter email address',
  'leads.detail.contactForm.phonePlaceholder': 'Enter phone number',
  'leads.detail.contactForm.commsPlaceholder': 'Select preferred communication method',
  'leads.detail.contactForm.save': 'Save Contact Information',

  // Detail: Event Details
  'leads.detail.eventDetails.title': 'Event Details',
  'leads.detail.eventDetails.noData': 'No event details provided',
  'leads.detail.eventDetails.weddingDate': 'Wedding Date:',
  'leads.detail.eventDetails.location': 'Location:',
  'leads.detail.eventDetails.ceremony': 'Ceremony:',
  'leads.detail.eventDetails.reception': 'Reception:',

  // Detail: Event Form
  'leads.detail.eventForm.title': 'Event Details',
  'leads.detail.eventForm.weddingDate': 'Wedding Date',
  'leads.detail.eventForm.pickDate': 'Pick a date',
  'leads.detail.eventForm.eventLocation': 'Event Location',
  'leads.detail.eventForm.eventLocationPlaceholder': 'Enter event location/city',
  'leads.detail.eventForm.ceremonyVenue': 'Ceremony Venue',
  'leads.detail.eventForm.ceremonyVenuePlaceholder': 'Enter ceremony venue',
  'leads.detail.eventForm.receptionVenue': 'Reception Venue',
  'leads.detail.eventForm.receptionVenuePlaceholder': 'Enter reception venue',
  'leads.detail.eventForm.save': 'Save Event Details',

  // Detail: Decision Making
  'leads.detail.decision.title': 'Decision Making',
  'leads.detail.decision.noData': 'No decision-making information provided',
  'leads.detail.decision.participants': 'Decision Participants:',
  'leads.detail.decision.timeline': 'Timeline:',
  'leads.detail.decision.consideringAlso': 'Considering Also:',
  'leads.detail.decision.timeline.urgent': 'Urgent (< 1 month)',
  'leads.detail.decision.timeline.short': 'Short term (1-3 months)',
  'leads.detail.decision.timeline.medium': 'Medium term (3-6 months)',
  'leads.detail.decision.timeline.long': 'Long term (6+ months)',
  'leads.detail.decision.timeline.flexible': 'Flexible timeline',

  // Detail: Decision Form
  'leads.detail.decisionForm.title': 'Decision Making Information',
  'leads.detail.decisionForm.buyingTimeline': 'Buying Timeline',
  'leads.detail.decisionForm.selectTimeline': 'Select buying timeline',
  'leads.detail.decisionForm.participants': 'Decision Participants',
  'leads.detail.decisionForm.addParticipant': 'Add a decision participant',
  'leads.detail.decisionForm.customParticipant': 'Or enter custom participant',
  'leads.detail.decisionForm.competitors': 'Competitors / Also Considering',
  'leads.detail.decisionForm.addCompetitor': 'Add a competitor',
  'leads.detail.decisionForm.customCompetitor': 'Or enter custom competitor',
  'leads.detail.decisionForm.save': 'Save Decision Making Info',

  // Detail: Dress Preferences
  'leads.detail.dress.title': 'Dress Preferences',
  'leads.detail.dress.noData': 'No dress preferences provided',
  'leads.detail.dress.styles': 'Preferred Styles:',
  'leads.detail.dress.brands': 'Preferred Brands:',
  'leads.detail.dress.size': 'Dress Size:',
  'leads.detail.dress.inspiration': 'Inspiration Images:',
  'leads.detail.dress.moreImages': '+{count} more images',

  // Detail: Dress Form
  'leads.detail.dressForm.title': 'Dress Preferences',
  'leads.detail.dressForm.budgetRange': 'Budget Range (€)',
  'leads.detail.dressForm.minimum': 'Minimum',
  'leads.detail.dressForm.maximum': 'Maximum',
  'leads.detail.dressForm.size': 'Dress Size',
  'leads.detail.dressForm.selectSize': 'Select dress size',
  'leads.detail.dressForm.sizePrefix': 'Size',
  'leads.detail.dressForm.styles': 'Preferred Styles',
  'leads.detail.dressForm.addStyle': 'Add a style preference',
  'leads.detail.dressForm.brands': 'Preferred Brands',
  'leads.detail.dressForm.addBrand': 'Add a brand preference',
  'leads.detail.dressForm.inspirationImages': 'Inspiration Images (up to 5 URLs)',
  'leads.detail.dressForm.imageUrlPlaceholder': 'Enter image URL (Pinterest, Instagram, etc.)',
  'leads.detail.dressForm.save': 'Save Dress Preferences',

  // Detail: Personalization
  'leads.detail.personalization.title': 'Personalization Notes',
  'leads.detail.personalization.noNotes': 'No personalization notes added yet. Click edit to add special requests, preferred experiences, or emotional notes.',
  'leads.detail.personalization.editTitle': 'Edit Personalization Notes',
  'leads.detail.personalization.label': 'Special Requests, Preferred Experience & Emotional Notes',
  'leads.detail.personalization.placeholder': 'Enter special requests, preferred experience details, emotional notes, or any other personalized information about this bride...',
  'leads.detail.personalization.success': 'Personalization notes updated successfully',
  'leads.detail.personalization.error': 'Failed to update personalization notes',

  // Detail: Cross-sell
  'leads.detail.crossSell.title': 'Cross-sell Opportunities',
  'leads.detail.crossSell.bridesmaids': 'Bridesmaids Dresses',
  'leads.detail.crossSell.bridesmaidsDesc': 'Interest in bridesmaids dress shopping',
  'leads.detail.crossSell.accessories': 'Accessories',
  'leads.detail.crossSell.accessoriesDesc': 'Interest in veils, jewelry, and accessories',
  'leads.detail.crossSell.alterations': 'Alterations',
  'leads.detail.crossSell.alterationsDesc': 'Interest in professional dress alterations',
  'leads.detail.crossSell.summary': '{count} of 3 cross-sell opportunities identified',
  'leads.detail.crossSell.success': 'Cross-sell interest updated successfully',
  'leads.detail.crossSell.error': 'Failed to update cross-sell interest',

  // Detail: Lead Management
  'leads.detail.management.title': 'Lead Management',
  'leads.detail.management.currentStage': 'Current Stage',
  'leads.detail.management.selectStage': 'Select stage',
  'leads.detail.management.followUpTimeline': 'Follow-up Timeline',
  'leads.detail.management.addNote': 'Add Note',
  'leads.detail.management.notePlaceholder': 'Add a follow-up note...',
  'leads.detail.management.noNotes': 'No follow-up notes yet. Add a note to track progress.',
  'leads.detail.management.reminder': 'Reminder',
  'leads.detail.management.stageSuccess': 'Lead stage updated successfully',
  'leads.detail.management.stageError': 'Failed to update lead stage',
  'leads.detail.management.noteSuccess': 'Follow-up note added successfully',
  'leads.detail.management.noteError': 'Failed to add follow-up note',

  // Detail: Pipeline Form
  'leads.detail.pipeline.title': 'Lead Pipeline Information',
  'leads.detail.pipeline.source': 'Lead Source',
  'leads.detail.pipeline.sourcePlaceholder': 'e.g., Google Ads, Referral, Walk-in',
  'leads.detail.pipeline.campaignId': 'Campaign ID',
  'leads.detail.pipeline.campaignIdPlaceholder': 'First touch campaign ID',
  'leads.detail.pipeline.healthScore': 'Health Score (1-5)',
  'leads.detail.pipeline.healthPlaceholder': 'Select health score',
  'leads.detail.pipeline.health1': '1 - Cold',
  'leads.detail.pipeline.health2': '2 - Cool',
  'leads.detail.pipeline.health3': '3 - Warm',
  'leads.detail.pipeline.health4': '4 - Hot',
  'leads.detail.pipeline.health5': '5 - Very Hot',
  'leads.detail.pipeline.nextContactDate': 'Next Contact Date',
  'leads.detail.pipeline.firstVisitDate': 'First Visit Date',
  'leads.detail.pipeline.pickDate': 'Pick a date',
  'leads.detail.pipeline.budgetMin': 'Budget Min ($)',
  'leads.detail.pipeline.budgetMinPlaceholder': 'Minimum budget',
  'leads.detail.pipeline.budgetMax': 'Budget Max ($)',
  'leads.detail.pipeline.budgetMaxPlaceholder': 'Maximum budget',
  'leads.detail.pipeline.lostReason': 'Lost Reason (if applicable)',
  'leads.detail.pipeline.lostReasonPlaceholder': 'Reason if lead was lost',
  'leads.detail.pipeline.notes': 'Pipeline Notes',
  'leads.detail.pipeline.notesPlaceholder': "Internal notes about this lead's pipeline status",
  'leads.detail.pipeline.save': 'Save Pipeline Information',

  // Detail: Comments
  'leads.detail.comments.title': 'Add Comment',
  'leads.detail.comments.placeholder': 'Add a comment...',
  'leads.detail.comments.adding': 'Adding...',
  'leads.detail.comments.addButton': 'Add Comment',
  'leads.detail.comments.noComments': 'No comments yet',
  'leads.detail.comments.beFirst': 'Be the first to add a comment about this lead',
  'leads.detail.comments.unknownUser': 'Unknown User',
  'leads.detail.comments.loginRequired': 'You must be logged in to view comments',
  'leads.detail.comments.loadError': 'Failed to load comments',
  'leads.detail.comments.loginToAdd': 'You must be logged in to add comments',
  'leads.detail.comments.addSuccess': 'Comment added successfully',
  'leads.detail.comments.addError': 'Failed to add comment',

  // Detail: Appointment History
  'leads.detail.appointmentHistory.title': 'Appointment History',
  'leads.detail.appointmentHistory.upcoming': '{count} upcoming',
  'leads.detail.appointmentHistory.past': '{count} past',
  'leads.detail.appointmentHistory.noAppointments': 'No appointments scheduled',
  'leads.detail.appointmentHistory.notes': 'Notes: ',

  // Detail: Custom Fields
  'leads.detail.customFields.title': 'Custom Fields',
  'leads.detail.customFields.noFields': 'No custom fields available',
  'leads.detail.customFields.noFieldsDescription': 'Custom fields from form submissions will appear here',
  'leads.detail.customFields.noFieldsDesc': 'Custom fields from form submissions will appear here',
  'leads.detail.customFields.edit': 'Edit',
  'leads.detail.customFields.searchPlaceholder': 'Search custom fields...',
  'leads.detail.customFields.all': 'All',
  'leads.detail.customFields.showEmpty': 'Show empty fields',
  'leads.detail.customFields.hideEmpty': 'Hide empty fields',
  'leads.detail.customFields.of': 'of',
  'leads.detail.customFields.fields': 'fields',
  'leads.detail.customFields.fieldCount': '{filtered} of {total} fields',
  'leads.detail.customFields.noMatch': 'No fields match your search criteria',
  'leads.detail.customFields.clearFilters': 'Clear filters',
  'leads.detail.customFields.saveChanges': 'Save Changes',

  // Detail: Sections
  'leads.detail.sections': 'Sections',
  'leads.detail.page.loadLeadError': 'Failed to load lead information',
  'leads.detail.page.unsavedConfirm': 'You have unsaved changes. Are you sure you want to leave?',
  'leads.detail.page.unknownLead': 'Unknown Lead',
  'leads.detail.page.notFound': 'Lead Not Found',
  'leads.detail.page.backToLeads': 'Back to Leads',
  'leads.detail.page.back': 'Back',
  'leads.detail.page.leadMeta': 'Lead ID: {id} • Created {createdAt}',
  'leads.detail.page.unsaved': '{count} unsaved',
  'leads.detail.page.quickActions': 'Quick Actions',
  'leads.detail.page.call': 'Call',
  'leads.detail.page.email': 'Email',
  'leads.detail.page.book': 'Book',
  'leads.detail.page.generalNotes': 'General Notes',
  'leads.detail.page.generalNotesPlaceholder': 'Enter general notes...',
  'leads.detail.page.notesUpdated': 'Notes updated successfully',
  'leads.detail.page.save': 'Save',
  'leads.detail.page.noNotesAvailable': 'No notes available',
  'leads.detail.customFields.success': 'Custom fields updated successfully',
  'leads.detail.page.noPhoneTitle': 'No Phone Number',
  'leads.detail.page.noPhoneDescription': 'No phone number available for this customer.',
  'leads.detail.page.messageTitle': 'Message Feature',
  'leads.detail.page.messageComingSoon': 'Message feature coming soon!',
  'leads.detail.page.changesSaved': 'Changes saved successfully.',
  'leads.detail.page.saveChangesError': 'Failed to save changes.',
  'leads.detail.page.loadingLeadDetails': 'Loading lead details...',
  'leads.detail.page.notFoundDescription': "The lead you're looking for doesn't exist or you don't have permission to view it.",
  'leads.detail.page.message': 'Message',
  'leads.detail.page.appointment': 'Appointment',
  'leads.detail.page.name': 'Name',
  'leads.detail.page.notSet': 'Not set',
  'leads.detail.page.notSpecified': 'Not specified',
  'leads.detail.page.notRated': 'Not rated',
  'leads.detail.page.notScheduled': 'Not scheduled',
  'leads.detail.page.budgetRange': 'Budget Range',
  'leads.detail.page.unlimited': 'unlimited',

  // Kanban Card
  'leads.followUp': 'Follow-up',
  'leads.wedding': 'Wedding:',
  'leads.budget': 'Budget:',
};
